var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2727 14.2724H4.72726M22.4545 3.36328V8.81783M11.5454 3.36328V8.81783M14.9545 19.7269L17 18.3633V25.1815M15.2954 25.1815H18.7045M11.2727 30.636H22.7273C25.0184 30.636 26.164 30.636 27.039 30.1901C27.8088 29.7979 28.4346 29.1721 28.8268 28.4023C29.2727 27.5272 29.2727 26.3817 29.2727 24.0906V12.636C29.2727 10.3449 29.2727 9.19932 28.8268 8.32423C28.4346 7.55448 27.8088 6.92865 27.039 6.53644C26.164 6.09055 25.0184 6.09055 22.7273 6.09055H11.2727C8.9816 6.09055 7.83603 6.09055 6.96094 6.53644C6.19119 6.92865 5.56536 7.55448 5.17315 8.32423C4.72726 9.19932 4.72726 10.3449 4.72726 12.636V24.0906C4.72726 26.3817 4.72726 27.5272 5.17315 28.4023C5.56536 29.1721 6.19119 29.7979 6.96094 30.1901C7.83603 30.636 8.9816 30.636 11.2727 30.636Z",
    stroke: "#F9A000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.090a4faf8a1d29330ca95abe4379a397.svg";
export { ForwardRef as ReactComponent };